import getFetchNonce from '@github-ui/fetch-nonce'
import {ssrSafeWindow} from '@github-ui/ssr-utils'

const globalFetch = fetch

export default function applyFetchPatch() {
  if (ssrSafeWindow) {
    const nonce = getFetchNonce()

    ssrSafeWindow.fetch = async (input: string | URL | Request, init?: RequestInit) => {
      if (input instanceof Request) {
        input.headers.set('X-Fetch-Nonce', nonce)
        return globalFetch(input, init)
      }

      if (init) {
        init['headers'] = {
          ...init['headers'],
          'X-Fetch-Nonce': nonce,
        }
      } else {
        init = {
          headers: {
            'X-Fetch-Nonce': nonce,
          },
        }
      }

      return globalFetch(input, init)
    }
  }
}
